import React, { useCallback, useState, useEffect } from 'react'
import { Button, Loader, Datagrid } from '@refera/ui-web'
import HeaderTitle from '_/components/header-title'
import useStyles, { datagridStyle } from './styles'
import { navigate, useParams } from '@reach/router'
import { Grid } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from '_/utils/constants'
import { ColumnsBuilding } from '../constants'
import { getBuildingsByAgency, getAgencyFull } from '_/modules/agency/actions'
import { agencySelector } from '_/modules/agency/selectors'
import { useToast } from '_/hooks/use-toast'

const Buildings = () => {
  const styles = useStyles()
  const { showToast } = useToast()
  const dispatch = useDispatch()
  const agency = useSelector(agencySelector)
  const { agencyId } = useParams()

  const [isLoading, setIsLoading] = useState(false)
  const [buildings, setBuildings] = useState([])

  const handleEditProcedure = useCallback(event => {
    navigate(`${ROUTES.AGENCY}/${agencyId}/empreendimento/${event.row.id}`)
  }, [])

  const handleBackNavigation = useCallback(() => {
    return navigate(`${ROUTES.AGENCY}/${agencyId}`)
  }, [navigate, agencyId])

  const handleAddNewBuilding = useCallback(() => {
    navigate(`${ROUTES.AGENCY}/${agencyId}/empreendimento/`)
  }, [navigate, agencyId])

  const fetchBuildings = useCallback(() => {
    setIsLoading(true)
    dispatch(getBuildingsByAgency(agencyId))
      .then(data => {
        setBuildings(data?.results || [])
        setIsLoading(false)
      })
      .catch(() => {
        showToast({ type: 'error', message: 'Ocorreu um erro ao buscar os empreendimentos.' })
        setIsLoading(false)
      })
  }, [dispatch, agencyId, showToast])

  useEffect(() => {
    fetchBuildings()
    if (agencyId) {
      dispatch(getAgencyFull(agencyId))
    }
  }, [fetchBuildings, agencyId])

  return (
    <>
      <Loader open={isLoading} hasBackdrop />
      <HeaderTitle
        title={agency?.propertiesTerm ? agency?.propertiesTerm : 'Empreendimentos'}
        backButtonAction={handleBackNavigation}
      >
        <Grid className={styles.headerButtons}>
          <Button variant="primary" onClick={handleAddNewBuilding} disabled={isLoading}>
            Novo
          </Button>
        </Grid>
      </HeaderTitle>
      {/* Grid separada do HeaderTitle para ficar abaixo do cabeçalho */}
      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            loading={isLoading}
            rows={buildings}
            columns={ColumnsBuilding()}
            paginationMode="server"
            sx={datagridStyle}
            onRowClick={handleEditProcedure}
            // onCellClick={handleCellClick}
            checkboxSelection={false}
            disableSelectionOnClick
          />
        </Grid>
      </Grid>
    </>
  )
}

export default Buildings
